import comboSizeColorViewersTemplate from '../templates/comboSizeColorViewers.html';

function comboSizeColorViewersDirective() {
    return {
        restrict: 'E',
        controller: function () {},
        controllerAs: 'comboSizeColorViewers',
        bindToController: true,
        scope: {
            ctrl: '<',
        },
        templateUrl: comboSizeColorViewersTemplate,
    };
}

export { comboSizeColorViewersDirective };
